import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Link,
  useColorModeValue,
  Icon,
  Container
} from "@chakra-ui/react";
import { MdArrowBack } from "react-icons/md";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as LystoLogo } from "assets/img/lysto-logo-round.svg";

const LegalHeader = () => {
  // Theme Colors
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "white");
  const linkColor = useColorModeValue("blue.500", "blue.300");
  const location = useLocation();
  const navigate = useNavigate();
  
  // Determine scroll target based on current path
  let scrollTarget = "";
  if (location.pathname.includes("privacy")) {
    scrollTarget = "privacy";
  } else if (location.pathname.includes("terms")) {
    scrollTarget = "terms";
  }
  
  // Handle navigation and scrolling - two approaches
  // 1. Using the RouterLink with localStorage
  const handleBackToLanding = (e) => {
    e.preventDefault(); // Prevent the RouterLink default behavior
    
    // User requested to scroll to top of landing page, not to footer links
    const scrollToTop = true;
    
    if (scrollToTop) {
      // If we want to scroll to top, we'll set a different flag
      localStorage.setItem("scrollToTop", "true");
    } else {
      // Original behavior - scroll to footer links
      localStorage.setItem("scrollToSection", scrollTarget);
    }
    
    navigate("/");
  };
  
  // 2. Using direct URL approach with an effect (this provides a backup method)
  useEffect(() => {
    // Set a flag in sessionStorage to identify a page load from this location
    sessionStorage.setItem("cameFromLegal", "top"); // Always scroll to top
    
    return () => {
      // If we navigate away but not to landing, clear the flag
      if (!window.location.pathname.includes("landing")) {
        sessionStorage.removeItem("cameFromLegal");
      }
    };
  }, []);
  
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="1000"
      bg={bgColor}
      boxShadow="sm"
      width="100%"
    >
      <Container maxW="1400px">
        <Flex
          alignItems="center"
          justifyContent="space-between"
          px={6}
          py={3}
          h="70px"
        >
          {/* Logo */}
          <Flex alignItems="center">
            <Box 
              w="32px" 
              h="32px" 
              mr={3} 
              display="flex" 
              alignItems="center" 
              justifyContent="center"
              borderRadius="10px"
              overflow="hidden"
            >
              <LystoLogo width="100%" height="100%" />
            </Box>
            <Text
              fontSize="2xl"
              fontWeight="bold"
              color={textColor}
              letterSpacing="tight"
            >
              Lysto
            </Text>
          </Flex>
          
          {/* Back to Landing Page Link */}
          <Link
            as={RouterLink}
            to="/"
            display="flex"
            alignItems="center"
            color={linkColor}
            fontWeight="medium"
            _hover={{ textDecoration: "none", opacity: 0.8 }}
            transition="opacity 0.2s"
            onClick={handleBackToLanding}
          >
            <Icon as={MdArrowBack} mr={2} />
            Back to Home
          </Link>
        </Flex>
      </Container>
    </Box>
  );
};

export default LegalHeader; 